import React from "react";

import { Route, Redirect } from "react-router-dom";

// components
import Unauthorized from "shared-components/logout/Unauthorized";

// state
import { connect } from "react-redux";

// utils
import { userTypeHasAccess } from "utils/accessControl";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { lStorage } from "utils/storage";
import { isLoginAuth } from "utils/common";

/* eslint-disable no-param-reassign */
const AuthGuard = ({ component: Component, authed, type, ld, ...rest }) => {
  const location = useLocation();
  const { isUser, user_role } = lStorage.get("authInfo") || {};
  const hasAccess = userTypeHasAccess(location?.pathname);

  if (authed === undefined || authed === null) {
    authed = isUser;
  }

  if (type === undefined || type === null) {
    type = user_role;
  }
  return (
    <Route
      {...rest}
      render={(props) => {
        if (authed) {
          return hasAccess ? <Component {...props} /> : <Unauthorized />;
        }
        const redirectPath = isLoginAuth() ? "/unauthorized" : null;
        return redirectPath ? (
          <Redirect to={{ pathname: redirectPath, state: { from: props.location } }} />
        ) : null;
        
      }}
    />
  );
};

// export default Login
const mapStateToProps = (state) => ({
  ld: state.loginDetails,
  ad: state.appDetails,
});

export default connect(mapStateToProps)(AuthGuard);
